import { ITeamWorkingHours, IWorkingDay } from '../Models/CareTeams/TeamWorkingHours.model';

export const isAppointmentOutsideTeamHours = (appointmentDate: Date, workingHours: ITeamWorkingHours): { isOutside: boolean; warning?: string } => {
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayOfWeek = appointmentDate.getDay();
    const dayName = dayNames[dayOfWeek] as keyof ITeamWorkingHours;

    const workingDay = workingHours[dayName] as IWorkingDay;

    if (!workingDay.StartsAt || !workingDay.EndsAt) {
        return {
            isOutside: true,
            warning: `Team does not operate on ${dayName}s`,
        };
    }

    const appointmentTime = appointmentDate.getHours() * 60 + appointmentDate.getMinutes();
    const [startHour, startMin] = workingDay.StartsAt.split(':').map(Number);
    const [endHour, endMin] = workingDay.EndsAt.split(':').map(Number);
    const startTime = startHour * 60 + startMin;
    const endTime = endHour * 60 + endMin;

    if (appointmentTime < startTime || appointmentTime > endTime) {
        return {
            isOutside: true,
            warning: `Team operates ${workingDay.StartsAt}-${workingDay.EndsAt} on ${dayName}s`,
        };
    }

    return { isOutside: false };
};

export const convertTeamHoursToMobiscrollInvalid = (workingHours: ITeamWorkingHours): any[] => {
    const invalid = [];
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    days.forEach((day, index) => {
        const workingDay = workingHours[day as keyof ITeamWorkingHours] as IWorkingDay;

        if (!workingDay.StartsAt || !workingDay.EndsAt) {
            invalid.push({
                recurring: {
                    repeat: 'weekly',
                    weekDays: [index],
                },
            });
        } else {
            invalid.push({
                recurring: {
                    repeat: 'weekly',
                    weekDays: [index],
                },
                start: '00:00',
                end: workingDay.StartsAt,
            });

            invalid.push({
                recurring: {
                    repeat: 'weekly',
                    weekDays: [index],
                },
                start: workingDay.EndsAt,
                end: '23:59',
            });
        }
    });

    return invalid;
};

export const validateTimeFormat = (time: string): boolean => {
    return /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/.test(time);
};

export const formatTime12Hour = (time24: string): string => {
    if (!time24) return '';
    const [hoursStr, minutes] = time24.split(':');
    const hours = parseInt(hoursStr, 10);
    const period = hours >= 12 ? 'PM' : 'AM';
    const hours12 = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
    return `${hours12}:${minutes} ${period}`;
};

export const formatWorkingDay = (day: IWorkingDay): string => {
    if (!day.StartsAt || !day.EndsAt) return 'Not schedulable';
    return `${formatTime12Hour(day.StartsAt)} - ${formatTime12Hour(day.EndsAt)}`;
};

